import Vue from 'vue'
import axios from 'axios'
import store from '~/store'
import router from '~/router'
// import Swal from 'sweetalert2'
// import i18n from '~/plugins/i18n'

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API + '/b'
Vue.prototype.$http = axios

// Request interceptor
axios.interceptors.request.use(
	request => {
		const token = store.getters['auth/token']
		if (token) {
			request.headers.common.Authorization = `Bearer ${token}`
		}

		/* const locale = store.getters['lang/locale']
	if (locale) {
		request.headers.common['Accept-Language'] = locale
	} */

		// request.headers['X-Socket-Id'] = Echo.socketId()

		return request
	},
	error => {
		return Promise.reject(error)
	}
)

// Response interceptor
axios.interceptors.response.use(
	response => {
		return response
	},
	error => {
		if (!error.response) {
			alert(error.message)
			return Promise.reject({ response: { data: { errors: {} } } })
		}

		const { status } = error.response

		if (status >= 500) {
			alert('error 500')
		}

		if (status === 401 && !store.getters['auth/check']) {
			store.commit('auth/LOGOUT')
			router.push({ name: 'login' })
		}

		// console.error(error.response.data)
		// alert(`CHYBA ${status} \n ${statusText} \n ${JSON.stringify(error.response.data)}`)

		return Promise.reject(error)
	}
)
